export const notes = (state) => state.notes
